module.exports = __webpack_public_path__ + "img/背景2.2b373759.jpg";